import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { useContext, useEffect, useState, Context as ReactContext } from 'react';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { DataOwnerRequestRecord } from '../../Common/DataOwnerModels/DataOwnerRequestRecord';

/*export function useGetFullRequestDetailsByReqId(requestId: string, shouldReload: boolean, httpClient: IHttpClient) {
  //const [dataOwnerFullReqDetails, setDataOwnerFullReqDetails] = useState<IDataOwnerRequestDetails>(null);
  //const [isDataOwnerFullReqLoading, setIsDataOwnerFullReqLoading] = useState<boolean>(true);

  let isDataOwnerFullReqLoading: boolean = false;
  let dataOwnerFullReqDetails: IDataOwnerRequestDetails = null;
  useEffect(() => {
    /*
      Checking for false boolean because it reloads twice when shouldReload mutates
      false -> true -> false
    
    if (!shouldReload) {
      //setIsDataOwnerFullReqLoading(true);
      isDataOwnerFullReqLoading = true;
      httpClient
        .get<IDataOwnerRequestDetails>(
          `${__API_BASE_URL__}/tenant/getFullRequestDetailsById?requestId=${requestId}`,
          {
            resource: __CLIENT_ID__,
            headers: {
              'Content-Type': 'application/json',
              'X-Content-Type-Options': 'nosniff',
            },
          }
        )
        .then(({ data }) => {
          dataOwnerFullReqDetails = data;
          isDataOwnerFullReqLoading = false;
          //setDataOwnerFullReqDetails(data);
          //setIsDataOwnerFullReqLoading(false);
        });
    }
  }, [shouldReload, requestId]);

  return [dataOwnerFullReqDetails, isDataOwnerFullReqLoading] as const;
}*/

export function useGetAllRequestsByDataOwner(dataownerId: string, shouldReload: boolean) {
  const [dataownerRequestsList, setDataOwnerRequestsList] = useState<DataOwnerRequestRecord[]>([]);
  const [dataownerRequestsListLoading, setDataOwnerRequestsListLoading] = useState<boolean>(true);
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);

  useEffect(() => {
    /*
      Checking for false boolean because it reloads twice when shouldReload mutates
      false -> true -> false
    */
    if (!shouldReload) {
      setDataOwnerRequestsListLoading(true);
      httpClient
        .get<DataOwnerRequestRecord[]>(`${__API_BASE_URL__}/tenant/getAllRequestsByTenant?tenantId=${dataownerId}`, {
          resource: __CLIENT_ID__,
          headers: {
            'Content-Type': 'application/json',
            'X-Content-Type-Options': 'nosniff',
          },
        })
        .then(({ data }) => {
          const filteredByUpdatedDateList: DataOwnerRequestRecord[] = data;
          filteredByUpdatedDateList.sort((a, b) => b.submittedDate.localeCompare(a.submittedDate));
          setDataOwnerRequestsList(data);
          setDataOwnerRequestsListLoading(false);
        });
    }
  }, [shouldReload]);

  return [dataownerRequestsList, dataownerRequestsListLoading] as const;
}
